import Repository from '../../repositories/RepositoryFactory';
const ccmMedicationEventRepository = Repository.get('ccmMedicationEvents');

export default {
	namespaced: true,
	state: {
		ccmMedicationEventByPatientId: [],
		ccmMedicationEventByCCMRecordId: [],
		ccmMedicationEvent: null,
	},
	mutations: {
		ADD_CCM_MEDICAL_EVENT_IN_PATIENT_LIST (state, payload) {
			state.ccmMedicationEventByPatientId.unshift(payload);
		},
		STORE_CCM_MEDICAL_EVENT_BY_PATIENT_ID (state, payload) {
			state.ccmMedicationEventByPatientId = payload;
		},
		STORE_CCM_MEDICAL_EVENT_BY_CCM_RECORD_ID (state, payload) {
			state.ccmMedicationEventByCCMRecordId = payload;
		},
		STORE_CCM_MEDICAL_EVENT (state, payload) {
			state.ccmMedicationEvent = payload;
		},
		UPDATE_CCM_MEDICAL_EVENT (state, payload) {
			state.ccmMedicationEvent = {
				...state.ccmMedicationEvent,
				...payload,
			};
		},
		UPDATE_CCM_MEDICAL_EVENT_IN_PATIENT_LIST (state, payload) {
			const index = state.ccmMedicationEventByPatientId.findIndex((record) => record.id === payload.id);
			if (index !== -1) {
				state.ccmMedicationEventByPatientId.splice(index, 1, {
					...state.ccmMedicationEventByPatientId[index],
					...payload.body,
				});
			}
		},
		REMOVE_CCM_MEDICAL_EVENT (state, id) {
			state.ccmMedicationEventByPatientId = state.ccmMedicationEventByPatientId.filter((record) => record.id !== id);
		},
	},
	actions: {
		async getCCMMedicationEventByPatientId ({ commit }, patientId) {
			const response = await ccmMedicationEventRepository.getCCMMedicationEventByPatientId(patientId);
			commit('STORE_CCM_MEDICAL_EVENT_BY_PATIENT_ID', response.data);
		},

		async getCCMMedicationEventByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmMedicationEventRepository.getCCMMedicationEventByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_MEDICAL_EVENT_BY_CCM_RECORD_ID', response);
		},

		async getCCMMedicationEvent ({ commit }, id) {
			const response = await ccmMedicationEventRepository.getCCMMedicationEvent(id);
			commit('STORE_CCM_MEDICAL_EVENT', response.data);
		},

		async addCCMMedicationEvent ({ commit }, body) {
			const response = await ccmMedicationEventRepository.addCCMMedicationEvent(body);
			commit('ADD_CCM_MEDICAL_EVENT_IN_PATIENT_LIST', response.data);
			return response;
		},

		async updateCCMMedicationEvent ({ commit }, request) {
			commit('UPDATE_CCM_MEDICAL_EVENT', request.body);
			commit('UPDATE_CCM_MEDICAL_EVENT_IN_PATIENT_LIST', request);
			return await ccmMedicationEventRepository.updateCCMMedicationEvent(request.id, request.body);
		},

		async deleteCCMMedicationEvent ({ commit }, id) {
			commit('REMOVE_CCM_MEDICAL_EVENT', id);
			return await ccmMedicationEventRepository.deleteCCMMedicationEvent(id);
		},
	},
};
